import { RFLPTask } from '@sourcepilot/generated/rflp_tasks/api/rflptask';

/** A new chat that works on `projectId`, created ON it in one create (the
 *  attachment rides in the create): bound to it from its first write (one
 *  project per chat; Tom, 2026-10-20), never a moment unbound nor left
 *  unattached by a failed second write. Answers its id and the page to open
 *  it on, or null when it could not be made. */
export async function createProjectChat(projectId: string, projectName?: string | null): Promise<{ id: string; href: string } | null> {
  try {
    const saved = await new RFLPTask({ task_name: projectName || 'New chat', currently_attached_to: { id: projectId } } as any).save();
    if (!saved.id) return null;
    return { id: saved.id, href: `/projects/${projectId}?chat=${saved.id}&agent=RFLPTask` };
  } catch (error) {
    console.error('Failed to start a chat for the project:', error);
    return null;
  }
}
